<mat-chip
  [style.paddingLeft]="paddingLeft"
  [style.paddingRight]="paddingRight"
  [style.paddingTop]="paddingTop"
  [style.paddingBottom]="paddingBottom"
  [style.marginTop]="marginTop"
  [style.marginLeft]="marginLeft"
  [style.marginBottom]="marginBottom"
  [style.marginRight]="marginRight"
  [matTooltip]="tooltipText"
  [matTooltipPosition]="tooltipPosition"
  [highlighted]="input.highlighted | parse: context | async"
  [color]="color"
  [ngClass]="classes"
  (removed)="handleRemoved()"
  disableRipple
>
  @for (widget of input.children; track widget) {
    <ng-container [dynamicWidget]="widget" [context]="context" />
  }
  @let showRemove =
    isExpression(input.onRemove)
      ? (input.onRemove | parse: context | async)
      : input.onRemove;

  <!-- mat-chip content projection breaks when a nested @if is used -->
  @if (showRemove && input.removeButton) {
    <tb-button [input]="input.removeButton" [context]="context" matChipRemove />
  } @else if (showRemove) {
    <button matChipRemove>
      <mat-icon>cancel</mat-icon>
    </button>
  }
</mat-chip>
